import React from "react";
import Preview from "../Preview/Preview";
import {navigate} from "@reach/router";
import {articles} from "../../../Articles/articleDb";

const ListArticles = () => (
    <div>
        {articles.map((value) => {
            return <div
                key={value.uniqueKey}
                onClick={e => navigate(value.relativePath)}>
                <Preview
                    mainImage={value.image}
                    header={value.header}
                    date={value.date}
                    authorName={value.authorName}
                    authorSocialLinkType={value.authorSocialLinkType}
                    readTime={value.readTime}
                    summary={value.summary}
                    teaser={value.teaser}/>
            </div>
        })}
    </div>
);

export {ListArticles}
